import { createApp } from 'vue'
import App from './App.vue'
import router from "@/router";

import VueAxios from 'vue-axios'
import { i18n } from './i18n'

import { store } from "@/store";
import apiClient from './http-common';

import './styles/app.scss'

createApp(App)
    .use(router)
    .use(store)
    .use(VueAxios, apiClient)
    .use(i18n)
    .mount('#app')
